module.exports = __webpack_public_path__ + "img/malta.bfd8125.webp";